var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { DraftType } from "@@/Draft";
import { ProjectObjectType } from "@@/Project";
import { testIsMobile } from "@@/Util";
import { Box, Flex, Text, Icon, HStack, InputGroup, Input, Accordion, Button, AccordionItem, AccordionButton, AccordionPanel, Link, Checkbox, Tag } from "@chakra-ui/react";
import { MdClose } from "@react-icons/all-files/md/MdClose";
import { Observer, observer } from "mobx-react";
import React, { Suspense } from "react";
import { BeatLoader, ScaleLoader } from "react-spinners";
import { AppColor, FontSize } from "../const/AppDefaults";
import { StoreContext } from "../uistore/Rootstore";
import { ExpandableTree } from "./ExpandableTree";
import { FaFileExcel } from '@react-icons/all-files/fa/FaFileExcel';
import { FaFileWord } from '@react-icons/all-files/fa/FaFileWord';
import { FaProjectDiagram } from '@react-icons/all-files/fa/FaProjectDiagram';
import { FaRegFilePdf } from '@react-icons/all-files/fa/FaRegFilePdf';
import { MdBookmarkBorder } from '@react-icons/all-files/md/MdBookmarkBorder';
import { FaFile } from '@react-icons/all-files/fa/FaFile';
import { FiLock } from '@react-icons/all-files/fi/FiLock';
import { FloatingPdfConatinerState } from "./FloatingPdfConatiner";
import { MdLink } from "@react-icons/all-files/md/MdLink";
import { AnnotationType, NoteType } from "@@/Annotation";
import { TableVirtuoso } from "react-virtuoso";
import { ChoiceType, SchemaItemType } from "@@/Schema";
import { DateLib } from "@@/Datelib";
import { FaFilter } from "@react-icons/all-files/fa/FaFilter";
import { MdViewColumn } from "@react-icons/all-files/md/MdViewColumn";
import { FiExternalLink } from "@react-icons/all-files/fi/FiExternalLink";
import { FaClipboard } from "@react-icons/all-files/fa/FaClipboard";
import { Clipboard } from '@/util/Util';
import { MdMenu } from "@react-icons/all-files/md/MdMenu";
const VirtuableTable = React.lazy(async () => await import("../UIComponents/VirtuosoTable"));
const FloatingDatasheet = React.lazy(async () => await import("../UIComponents/FloatingDatasheet"));
const FilterPanel = React.lazy(async () => await import("../UIComponents/FilterDialog"));
let ObjectChooserDialog = class ObjectChooserDialog extends React.Component {
    constructor() {
        super(...arguments);
        this.boxref = null;
        this.adjustx = 0;
        this.adjusty = 0;
        this.upcb = () => {
            const rstore = this.context;
            rstore.objectChooserStore.setDragging(false);
        };
        this.mousemove = (e) => {
            const rstore = this.context;
            if (rstore.objectChooserStore.dragging) {
                // lets move this dialog 
                rstore.objectChooserStore.setTop(e.clientY - this.adjusty);
                rstore.objectChooserStore.setLeft(e.clientX - this.adjustx);
            }
        };
    }
    componentDidMount() {
        window.addEventListener("mouseup", this.upcb);
        window.addEventListener("mousemove", this.mousemove);
    }
    componentWillUnmount() {
        window.removeEventListener("mouseup", this.upcb);
        window.removeEventListener("mousemove", this.mousemove);
    }
    resetSearch() {
        const rstore = this.context;
        rstore.objectChooserStore.resetSearch();
        rstore.objectChooserStore.showHome(false);
    }
    checkAndSetSearchTerm(e) {
        const rstore = this.context;
        rstore.objectChooserStore.setSearchTerm(e.currentTarget.value);
    }
    performSearch(e) {
        const rstore = this.context;
        if (e.key.toLowerCase() === 'enter') {
            rstore.objectChooserStore.performSearch();
        }
    }
    addLink() {
        const rstore = this.context;
        const sid = rstore.objectChooserStore.activeitemid;
        const obj = rstore.objectChooserStore.getProjectObject(sid);
        if ((obj === null || obj === void 0 ? void 0 : obj.type) !== ProjectObjectType.Bookmark) {
            return;
        }
        const ismaindraft = rstore.draftDetailStore.showdraftingview;
        const bobj = obj;
        let marking = "text:" + 0 + ":" + -1 + ":" + 0 + ":" +
            -1;
        const databox = {
            detail: [{ key: 'systemtext', value: '' }],
            notetype: AnnotationType.Rectangle,
            boxes: [[0, 0, 0, 0]],
            match: marking,
            color: 'blue',
            storekthickness: -1
        };
        const note = {
            id: "",
            data: databox,
            type: NoteType.NoteLink,
            viewer: [],
            parentid: "",
            authorname: "",
            authorid: "",
            updatetime: 0,
            replycount: 0,
            aclstr: "---",
            notereference: bobj.id
        };
        const lnote = {
            objectid: bobj.id,
            fileid: bobj.id,
            name: bobj.name,
            note: note
        };
        // check if it's datasheet mode!!
        if (rstore.letrAndTagStore.activeview === 'datasheet') {
            rstore.mainSchemaStore.addLink(lnote);
        }
        else {
            if (ismaindraft) {
                rstore.draftDetailStore.setLink(lnote);
            }
            else {
                rstore.miniviewStore.setLink(lnote);
            }
        }
        rstore.floatingStore.setShow(false);
        rstore.floatingStore.reset();
        rstore.objectChooserStore.setShow(false);
        rstore.objectChooserStore.reset();
    }
    render() {
        const rstore = this.context;
        if (!rstore.objectChooserStore.show) {
            return React.createElement(React.Fragment, null);
        }
        return React.createElement(Box, { "object-chooser": 'colorbox', ref: (ref) => this.boxref = ref, bg: 'white', borderRadius: '4px', className: 'floating-dialog', zIndex: 5000, cursor: rstore.objectChooserStore.dragging ? 'grabbing' : '', onMouseDown: (e) => {
                var _a, _b;
                const tgt = e.target;
                if (tgt.getAttribute("object-chooser")) {
                    rstore.objectChooserStore.setDragging(true);
                    if (this.boxref) {
                        this.adjustx = e.clientX - ((_a = this.boxref) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left);
                        this.adjusty = e.clientY - ((_b = this.boxref) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().top);
                    }
                }
            }, position: 'fixed', left: rstore.objectChooserStore.left + "px", top: rstore.objectChooserStore.top + "px", width: rstore.objectChooserStore.width + "px", height: testIsMobile() ? (window.innerHeight - 150) + "px" : (window.innerHeight - 100) + "px" },
            rstore.objectChooserStore.showaddlinkbtn && React.createElement(Flex, { align: 'center', justify: 'center', flexDir: 'column', ml: '15px' },
                React.createElement(Box, { className: 'icon-button-box', padding: '5px', title: rstore.objectChooserStore.selectionmode ? 'Add Selection' : 'Add Link', onClick: () => this.addLink() },
                    React.createElement(Icon, { w: '20px', h: '20px', color: AppColor.ActionMenuIcon, className: 'message-option-button', as: MdLink, ml: '1px' }),
                    React.createElement(Text, { fontSize: FontSize.IconTitleFontSize, fontWeight: 'bold' }, rstore.objectChooserStore.selectionmode ? 'Add Selection' : 'Add Link'))),
            React.createElement(Flex, { padding: '10px', align: 'center', "object-chooser": 'colorbox', height: "35px", width: '100%' },
                !rstore.objectChooserStore.reportview && React.createElement(Flex, { align: 'center', "object-chooser": 'colorbox', width: '90%' },
                    rstore.letrAndTagStore.canViewDocument() && React.createElement(Box, { _hover: { cursor: 'pointer' }, onClick: () => {
                            rstore.objectChooserStore.setActiveView("project");
                        }, className: (rstore.objectChooserStore.activeview === 'project') ? 'tab-item active' : 'tab-item' },
                        React.createElement(Text, null, "Document")),
                    rstore.letrAndTagStore.canViewDatasheet() && React.createElement(Box, { _hover: { cursor: 'pointer' }, onClick: () => {
                            if (!rstore.objectChooserStore.selectionmode) {
                                rstore.floatingDatasheetStore.setLinkingMode(false);
                                rstore.floatingDatasheetStore.setLinkingMode(true);
                            }
                            else {
                                rstore.floatingStore.setSelectionmode(true);
                            }
                            rstore.floatingDatasheetStore.setObjectViewerMode(false);
                            rstore.objectChooserStore.setActiveView("datasheet");
                        }, className: (rstore.objectChooserStore.activeview === 'datasheet') ?
                            'tab-item active' : 'tab-item' },
                        React.createElement(Text, null, "Datasheet"))),
                React.createElement(Flex, { align: 'center', justify: 'flex-end', "object-chooser": 'colorbox', width: rstore.objectChooserStore.reportview ? '100%' : '10%' },
                    React.createElement(Icon, { ml: '20px', as: MdClose, color: AppColor.ResetFilter, h: '25px', w: '25px', _hover: { cursor: 'pointer' }, onClick: (e) => {
                            rstore.floatingDatasheetStore.footerruleexestate.setShow(false);
                            rstore.floatingDatasheetStore.footerruleexestate.reset();
                            rstore.objectChooserStore.setShow(false);
                        }, className: 'message-option-button' }))),
            testIsMobile() && rstore.objectChooserStore.activeview === 'project' && React.createElement(Box, { mt: '10px', pos: 'relative' },
                React.createElement(Icon, { w: '25px', h: '25px', onClick: () => rstore.objectChooserStore.setShowFolderChooser(!rstore.objectChooserStore.showfolderchooser), color: AppColor.TopBarIconColor, as: MdMenu, ml: '5px' }),
                rstore.objectChooserStore.showfolderchooser && React.createElement(Box, { pos: 'absolute', top: "30px", left: '0px', bg: 'white', className: rstore.objectChooserStore.showfolderchooser ? 'slide-right' : '', zIndex: 1000, borderColor: '#e5e4e4', borderWidth: '1px', backgroundColor: '#f2f2f2', padding: '2px' },
                    React.createElement(Box, { w: '300px', h: '60vh' },
                        React.createElement(Flex, null,
                            React.createElement(InputGroup, { size: 'sm', width: '60%' },
                                React.createElement(Input, { focusBorderColor: AppColor.HeaderIconColor, backgroundColor: '#FFFFFF', borderRadius: '10px', placeholder: 'Filter folders', onChange: (e) => rstore.objectChooserStore.setFilterFolderTerm(e.currentTarget.value), value: rstore.objectChooserStore.filterfolderterm, onKeyDown: (e) => {
                                        if (e.key.toLowerCase() === 'enter') {
                                            rstore.objectChooserStore.dofilterFolders();
                                        }
                                    } })),
                            React.createElement(Flex, { justify: 'flex-end', width: '40%', align: 'center' },
                                React.createElement(Icon, { w: '20px', h: '20px', onClick: () => rstore.objectChooserStore.setShowFolderChooser(false), color: AppColor.DeleteIconColor, as: MdClose }))),
                        React.createElement(Observer, null, () => React.createElement(ExpandableTree, { state: rstore.objectChooserStore.projecttreestate, width: '100%', height: '60vh', onSelect: (id) => {
                                const rstore = this.context;
                                rstore.objectChooserStore.setActiveFolderId(id);
                            }, onChecked: (id, check) => {
                                const rstore = this.context;
                            }, hidecheckb: true, showdocumenticon: true, documentIconClicked: (id) => {
                                const rstore = this.context;
                                rstore.objectChooserStore.setActiveFolderId(id);
                                rstore.objectChooserStore.setShowFolderChooser(false);
                            } })))),
                React.createElement(Box, { w: '95%', h: '60vh', marginLeft: '5px' },
                    React.createElement(Flex, { "border-bottom": '1px solid lightgray', justify: 'center', "object-chooser": 'colorbox', width: '100%' },
                        React.createElement(Box, { pos: 'relative', zIndex: 700 },
                            React.createElement(Flex, { align: 'center', justify: 'center', flexDir: 'column', ml: '15px' },
                                React.createElement(Box, { className: 'icon-button-box', padding: '5px', title: 'Show Columns', onClick: (e) => {
                                        e.stopPropagation();
                                        rstore.objectChooserStore.setShowColView(!rstore.objectChooserStore.showcolview);
                                    } },
                                    React.createElement(Icon, { w: '18px', h: '18px', color: AppColor.ActionMenuIcon, as: MdViewColumn, ml: '1px' })),
                                React.createElement(Text, { fontSize: FontSize.SmallIconLabel, fontWeight: 'bold' }, 'Columns')),
                            React.createElement(Box, { pos: 'absolute', top: '60px', bg: 'white' },
                                React.createElement(ColumnsView, null))),
                        React.createElement(Box, { pos: 'relative', zIndex: 700 },
                            React.createElement(Flex, { align: 'center', justify: 'center', flexDir: 'column', ml: '15px' },
                                React.createElement(Box, { className: 'icon-button-box', padding: '5px', title: 'Filter', onClick: (e) => {
                                        e.stopPropagation();
                                        rstore.objectChooserStore.setshowfilter(!rstore.objectChooserStore.showfilter);
                                    } },
                                    React.createElement(Icon, { w: '18px', h: '18px', color: (rstore.objectChooserStore.searchactive && rstore.objectChooserStore.filterdialogstate.valuesbyid.size > 0) ? 'green' :
                                            AppColor.ActionMenuIcon, as: FaFilter, ml: '1px' })),
                                React.createElement(Text, { fontSize: FontSize.SmallIconLabel, fontWeight: 'bold' }, 'Filter')),
                            testIsMobile() && React.createElement(Box, { pos: 'fixed', top: window.innerHeight / 4 + "px", left: '5%', bg: 'white', className: rstore.objectChooserStore.showfilter ? 'slide-right' : '', zIndex: 1000 },
                                React.createElement(FilterView, null)),
                            !testIsMobile() && React.createElement(Box, { pos: 'absolute', top: '60px', bg: 'white' },
                                React.createElement(FilterView, null))),
                        React.createElement(InputGroup, { width: '200px', size: 'sm' },
                            React.createElement(Input, { borderRadius: '10px', placeholder: 'Item Name', onChange: (e) => this.checkAndSetSearchTerm(e), value: rstore.objectChooserStore.searchterm, onKeyDown: (e) => {
                                    this.performSearch(e);
                                } })),
                        rstore.objectChooserStore.searchactive && React.createElement(Button, { onClick: () => this.resetSearch(), alignItems: 'center', ml: '10px', colorScheme: 'orange', size: 'sm' }, "Reset"),
                        rstore.objectChooserStore.searchactive && rstore.objectChooserStore.foundmsg && React.createElement(Text, { alignSelf: 'center', ml: '5px', fontSize: 14, fontWeight: 'bold', color: AppColor.MessageColor }, rstore.objectChooserStore.foundmsg)),
                    React.createElement(DocumentTable, null))),
            !testIsMobile() && rstore.objectChooserStore.activeview === 'project' && React.createElement(HStack, { spacing: '24px', mt: '10px' },
                React.createElement(Box, { w: '35%', h: '60vh' },
                    React.createElement(InputGroup, { size: 'sm', width: '50%' },
                        React.createElement(Input, { borderRadius: '10px', placeholder: 'Filter folders', onChange: (e) => rstore.objectChooserStore.setFilterFolderTerm(e.currentTarget.value), value: rstore.objectChooserStore.filterfolderterm, onKeyDown: (e) => {
                                if (e.key.toLowerCase() === 'enter') {
                                    rstore.objectChooserStore.dofilterFolders();
                                }
                            } })),
                    React.createElement(Observer, null, () => React.createElement(ExpandableTree, { state: rstore.objectChooserStore.projecttreestate, width: '100%', height: '60vh', onSelect: (id) => {
                            const rstore = this.context;
                            rstore.objectChooserStore.setActiveFolderId(id);
                        }, onChecked: (id, check) => {
                            const rstore = this.context;
                        } }))),
                React.createElement(Box, { w: '65%', h: '60vh' },
                    React.createElement(Flex, { "border-bottom": '1px solid lightgray', padding: '10px', justify: 'center', "object-chooser": 'colorbox', height: "35px", width: '100%' },
                        React.createElement(Box, { pos: 'relative', zIndex: 700 },
                            React.createElement(Flex, { align: 'center', justify: 'center', flexDir: 'column', ml: '15px' },
                                React.createElement(Box, { className: 'icon-button-box', padding: '5px', title: 'Show Columns', onClick: (e) => {
                                        e.stopPropagation();
                                        rstore.objectChooserStore.setShowColView(!rstore.objectChooserStore.showcolview);
                                    } },
                                    React.createElement(Icon, { w: '22px', h: '22px', color: AppColor.ActionMenuIcon, as: MdViewColumn, ml: '1px' })),
                                React.createElement(Text, { fontSize: FontSize.IconTitleFontSize, fontWeight: 'bold' }, 'Columns')),
                            React.createElement(Box, { pos: 'absolute', top: '60px', bg: 'white' },
                                React.createElement(ColumnsView, null))),
                        React.createElement(Box, { pos: 'relative', zIndex: 700 },
                            React.createElement(Flex, { align: 'center', justify: 'center', flexDir: 'column', ml: '15px' },
                                React.createElement(Box, { className: 'icon-button-box', padding: '5px', title: 'Filter', onClick: (e) => {
                                        e.stopPropagation();
                                        rstore.objectChooserStore.setshowfilter(!rstore.objectChooserStore.showfilter);
                                    } },
                                    React.createElement(Icon, { w: '22px', h: '22px', color: (rstore.objectChooserStore.searchactive && rstore.objectChooserStore.filterdialogstate.valuesbyid.size > 0) ? 'green' :
                                            AppColor.ActionMenuIcon, as: FaFilter, ml: '1px' })),
                                React.createElement(Text, { fontSize: FontSize.IconTitleFontSize, fontWeight: 'bold' }, 'Filter')),
                            React.createElement(Box, { pos: 'absolute', top: '60px', bg: 'white' },
                                React.createElement(FilterView, null))),
                        React.createElement(InputGroup, { width: '200px', size: 'sm' },
                            React.createElement(Input, { borderRadius: '10px', placeholder: 'Item Name', onChange: (e) => this.checkAndSetSearchTerm(e), value: rstore.objectChooserStore.searchterm, onKeyDown: (e) => {
                                    this.performSearch(e);
                                } })),
                        rstore.objectChooserStore.searchactive && React.createElement(Button, { onClick: () => this.resetSearch(), alignItems: 'center', ml: '10px', colorScheme: 'orange', size: 'sm' }, "Reset"),
                        rstore.objectChooserStore.searchactive && rstore.objectChooserStore.foundmsg && React.createElement(Text, { alignSelf: 'center', ml: '5px', fontSize: 14, fontWeight: 'bold', color: AppColor.MessageColor }, rstore.objectChooserStore.foundmsg)),
                    React.createElement(DocumentTable, null))),
            rstore.objectChooserStore.activeview === 'datasheet' &&
                React.createElement(Suspense, { fallback: React.createElement(Flex, { flexDirection: 'column', style: { height: '100%' }, justify: 'center', align: 'center' },
                        React.createElement(BeatLoader, { color: AppColor.MainLoaderColor }),
                        React.createElement(Text, { style: { fontWeight: 'bold', fontSize: '15px' } }, "Intialising...")) },
                    React.createElement(FloatingDatasheet, null)));
    }
};
ObjectChooserDialog.contextType = StoreContext;
ObjectChooserDialog = __decorate([
    observer
], ObjectChooserDialog);
export { ObjectChooserDialog };
let FilterView = class FilterView extends React.Component {
    render() {
        const rstore = this.context;
        if (!rstore.objectChooserStore.showfilter) {
            return React.createElement(React.Fragment, null);
        }
        return React.createElement(Box, { w: testIsMobile() ? '300px' : '400px', boxShadow: '10px 10px 10px lightgray', maxH: '500px', overflow: 'auto' },
            React.createElement(Suspense, { fallback: React.createElement(Flex, { flexDirection: 'column', style: { height: '100%' }, justify: 'center', align: 'center' },
                    React.createElement(ScaleLoader, { color: 'green' }),
                    React.createElement(Text, { style: { fontWeight: 'bold', fontSize: '15px' } }, "Intialising Content...")) },
                React.createElement(FilterPanel, { onClosePress: () => rstore.objectChooserStore.setshowfilter(false), onApply: () => rstore.objectChooserStore.performSearch(), state: rstore.objectChooserStore.filterdialogstate, items: rstore.objectChooserStore.getMetadata() })));
    }
};
FilterView.contextType = StoreContext;
FilterView = __decorate([
    observer
], FilterView);
export { FilterView };
let ColumnsView = class ColumnsView extends React.Component {
    render() {
        const rstore = this.context;
        if (!rstore.objectChooserStore.showcolview) {
            return React.createElement(React.Fragment, null);
        }
        return React.createElement(Box, { w: '200px', boxShadow: '10px 10px 10px lightgray' }, rstore.projectStore.cview.map((field) => React.createElement(Flex, { align: 'center', ml: '5px', w: '100%', h: '40px', key: field.id, _hover: { cursor: 'pointer', opacity: '0.9', backgroundColor: '#829eb975' } },
            React.createElement(Checkbox, { defaultChecked: !rstore.objectChooserStore.hidecoilumn.has(field.id), checked: !rstore.objectChooserStore.hidecoilumn.has(field.id), onChange: (e) => {
                    if (e.currentTarget.checked) {
                        rstore.objectChooserStore.showCol(field.id);
                    }
                    else {
                        rstore.objectChooserStore.hideCol(field.id);
                    }
                } }),
            React.createElement(Text, { title: field.label, ml: '10px', overflow: 'hidden', textOverflow: 'ellipsis', maxW: '200px', fontWeight: 'bold' }, field.label))));
    }
};
ColumnsView.contextType = StoreContext;
ColumnsView = __decorate([
    observer
], ColumnsView);
export { ColumnsView };
let DocumentTable = class DocumentTable extends React.Component {
    componentDidMount() {
        const rstore = this.context;
    }
    calRowHeight(id) {
        return 30;
    }
    onDraftClick(draft) {
        const rstore = this.context;
        rstore.objectChooserStore.setShowAddLinkBtn(false);
        rstore.floatingDraftViewStore.draftview = true;
        rstore.floatingDraftViewStore.setShowDraftingView(true);
        rstore.floatingDraftViewStore.resetNotes();
        rstore.floatingDraftViewStore.draftname = draft.name;
        rstore.floatingStore.setTitle(draft.name);
        rstore.floatingDraftViewStore.setLoadingDetails(false);
        rstore.floatingDraftViewStore.letrid = rstore.projectStore.activeletrid;
        rstore.floatingDraftViewStore.draftid = draft.draftreference;
        rstore.floatingDraftViewStore.objectid = draft.id;
        rstore.floatingDraftViewStore.accesskey = draft.accesskey;
        rstore.floatingDraftViewStore.setPasteProcessing(false);
        rstore.floatingDraftViewStore.drafttype = draft.drafttype;
        rstore.floatingStore.setActiveDocumentId("");
        rstore.floatingDraftViewStore.loadDraftDetail();
        rstore.floatingDraftViewStore.diagrapmpropertypanel.setDefaultTextProperty();
        rstore.floatingDraftViewStore.setView("detail");
        rstore.floatingStore.setLinkingmode(true);
        rstore.floatingDraftViewStore.getAllNotes();
        rstore.floatingStore.setShow(true);
    }
    bookmarkClicked(ob) {
        var _a, _b;
        const rstore = this.context;
        rstore.objectChooserStore.setShowAddLinkBtn(false);
        (_b = (_a = rstore.objectChooserStore).selectioncb) === null || _b === void 0 ? void 0 : _b.call(_a, { obj: ob, type: 'document',
            id: "objs-" + ob.id });
    }
    documentClicked(dmessgae, reshow = false) {
        var _a;
        const rstore = this.context;
        rstore.objectChooserStore.setShowAddLinkBtn(false);
        rstore.floatingDraftViewStore.draftview = true;
        rstore.floatingDraftViewStore.setShowDraftingView(false);
        rstore.floatingStore.reset();
        rstore.floatingStore.setTitle(dmessgae.name);
        rstore.floatingStore.setActiveDocumentId(dmessgae.id);
        rstore.objectChooserStore.setActiveItemid(dmessgae.id);
        rstore.floatingStore.draftid = "";
        rstore.floatingStore.info = {
            fileid: dmessgae.documentreference,
            letrid: rstore.projectStore.activeletrid,
            accesskey: dmessgae.accesskey,
            boxid: dmessgae.accesscode,
            version: (_a = dmessgae.versions) !== null && _a !== void 0 ? _a : [],
            replace: []
        };
        rstore.floatingStore.downloadMetadata();
        rstore.floatingStore.setShow(true);
        rstore.floatingPdfViewerStore.reset();
        rstore.floatingPdfViewerStore.activeletrid = rstore.projectStore.activeletrid;
        rstore.floatingPdfViewerStore.activeobjectid = dmessgae.id;
        rstore.floatingPdfViewerStore.activedraftid = dmessgae.documentreference;
        rstore.floatingDraftViewStore.letrid = rstore.projectStore.activeletrid;
        rstore.floatingDraftViewStore.objectid = dmessgae.id;
        rstore.floatingDraftViewStore.draftid = dmessgae.documentreference;
        rstore.floatingPdfViewerStore.getAllNotes();
        rstore.floatingPdfViewerStore.setTotalPages(rstore.floatingStore.pdfpagesdetails.length);
        rstore.floatingPdfViewerStore.increamentPageNumber();
        if (rstore.objectChooserStore.selectionmode) {
            rstore.floatingStore.setSelectionmode(true);
        }
        else {
            rstore.floatingStore.setLinkingmode(true);
        }
        FloatingPdfConatinerState.reset();
        setTimeout(() => FloatingPdfConatinerState.setShow(true), 100);
    }
    getIcon(type, drafttype) {
        if (type === ProjectObjectType.Document) {
            return React.createElement(Icon, { ml: '5px', color: AppColor.FileIconColor, h: '20px', w: '20px', as: FaRegFilePdf, alignSelf: 'center' });
        }
        else if (type === ProjectObjectType.Draft) {
            if (drafttype !== undefined && drafttype === DraftType.DOCX) {
                return React.createElement(Icon, { ml: '5px', color: AppColor.FileIconColor, h: '20px', w: '20px', as: FaFileWord, alignSelf: 'center' });
            }
            else if (drafttype !== undefined && drafttype === DraftType.XLSX) {
                return React.createElement(Icon, { ml: '5px', color: AppColor.FileIconColor, h: '20px', w: '20px', as: FaFileExcel, alignSelf: 'center' });
            }
            else if (drafttype !== undefined && drafttype === DraftType.Diagram) {
                return React.createElement(Icon, { ml: '5px', color: AppColor.FileIconColor, h: '20px', w: '20px', as: FaProjectDiagram, alignSelf: 'center' });
            }
            else if (drafttype !== undefined && drafttype === DraftType.PPTX) {
                return React.createElement(Icon, { ml: '5px', color: AppColor.FileIconColor, h: '20px', w: '20px', as: FaFile, alignSelf: 'center' });
            }
        }
        else if (type === ProjectObjectType.Bookmark) {
            return React.createElement(Icon, { ml: '5px', color: AppColor.FileIconColor, h: '20px', w: '20px', as: MdBookmarkBorder, alignSelf: 'center' });
        }
        else {
            return React.createElement(Icon, { ml: '5px', color: AppColor.FileIconColor, h: '20px', w: '20px', as: FaFile, alignSelf: 'center' });
        }
    }
    render() {
        const rstore = this.context;
        if (rstore.objectChooserStore.loadingfoldercontent || rstore.objectChooserStore.searching) {
            return React.createElement(Flex, { h: '100%', w: '100%', justify: 'center', align: 'center' },
                React.createElement(Box, null,
                    React.createElement(ScaleLoader, { color: 'green' }),
                    rstore.objectChooserStore.searching && React.createElement(Text, { mt: '10px' }, rstore.objectChooserStore.searchprogressmessage)));
        }
        return React.createElement(Box, { w: '100%', h: testIsMobile() ? window.innerHeight - 300 : window.innerHeight - 200 },
            React.createElement(Observer, null, () => React.createElement(TableVirtuoso, { className: "styled-table", data: rstore.objectChooserStore.documentTableState.getRows(), style: { height: testIsMobile() ? window.innerHeight - 300 : window.innerHeight - 200 }, components: { Table: (_a) => {
                        var { style } = _a, props = __rest(_a, ["style"]);
                        return React.createElement("table", Object.assign({}, props, { style: Object.assign(Object.assign({}, style), { minWidth: testIsMobile() ? window.innerWidth - 50 : 700 }) }));
                    } }, fixedHeaderContent: () => (React.createElement("tr", null,
                    React.createElement("th", null),
                    rstore.objectChooserStore.documentTableState.getHeaders().map((item) => {
                        return React.createElement("th", { key: item.id, style: {
                                minWidth: 200,
                                width: 400, backgroundColor: 'whiteAlpha.500', borderRightWidth: '1px',
                                borderRightColor: '#d3dbe2'
                            } }, item.label);
                    }))), itemContent: (index, row) => React.createElement(Observer, null, () => React.createElement(NewObjectRow, { key: row.id, objectrow: row, onSelect: (obj, checked) => {
                        const rstore = this.context;
                        const id = obj.id;
                        if (!checked) {
                            rstore.objectChooserStore.setActiveItemid("");
                            rstore.documentDetailStore.setActiveDocumentId("");
                            rstore.draftDetailStore.setView("detail");
                            rstore.letrAndTagStore.setActiveViewer('chat');
                            rstore.draftDetailStore.draftid = "";
                            rstore.projectStore.setViewerActive(false);
                            rstore.objectChooserStore.setShowAddLinkBtn(false);
                        }
                        else {
                            const ob = rstore.objectChooserStore.getProjectObject(id);
                            // if (FloatingPf.activefileid === id) {
                            //     return;
                            // }
                            FloatingPdfConatinerState.clear();
                            if ((ob === null || ob === void 0 ? void 0 : ob.type) === ProjectObjectType.Document) {
                                this.documentClicked(ob);
                            }
                            else if ((ob === null || ob === void 0 ? void 0 : ob.type) === ProjectObjectType.Draft) {
                                this.onDraftClick(ob);
                            }
                            else if ((ob === null || ob === void 0 ? void 0 : ob.type) === ProjectObjectType.Bookmark) {
                                rstore.objectChooserStore.setActiveItemid(id);
                                this.bookmarkClicked(ob);
                            }
                        }
                    } })) })));
    }
    render_old() {
        const rstore = this.context;
        if (rstore.objectChooserStore.loadingfoldercontent || rstore.objectChooserStore.searching) {
            return React.createElement(Flex, { h: '100%', w: '100%', justify: 'center', align: 'center' },
                React.createElement(Box, null,
                    React.createElement(ScaleLoader, { color: 'green' }),
                    rstore.objectChooserStore.searching && React.createElement(Text, { mt: '10px' }, rstore.objectChooserStore.searchprogressmessage)));
        }
        return React.createElement(Suspense, { fallback: React.createElement(Flex, { flexDirection: 'column', style: { height: '100%' }, justify: 'center', align: 'center' },
                React.createElement(ScaleLoader, { color: 'green' }),
                React.createElement(Text, { style: { fontWeight: 'bold', fontSize: '15px' } }, "Intialising Content...")) },
            React.createElement(VirtuableTable, { onSelect: (id, checked) => {
                    const ob = rstore.objectChooserStore.getProjectObject(id);
                    FloatingPdfConatinerState.clear();
                    if ((ob === null || ob === void 0 ? void 0 : ob.type) === ProjectObjectType.Document) {
                        this.documentClicked(ob);
                    }
                    else if ((ob === null || ob === void 0 ? void 0 : ob.type) === ProjectObjectType.Draft) {
                        this.onDraftClick(ob);
                    }
                    else if ((ob === null || ob === void 0 ? void 0 : ob.type) === ProjectObjectType.Bookmark) {
                        this.bookmarkClicked(ob);
                    }
                    else {
                        rstore.objectChooserStore.setShowAddLinkBtn(false);
                    }
                }, onChecked: (id, check) => {
                    const rstore = this.context;
                }, includecheckbox: false, selectablerow: true, state: rstore.objectChooserStore.documentTableState, columndraggable: false, width: '100%', height: window.innerHeight * .6, rowheight: (id) => this.calRowHeight(id), columnrender: (id, rowid, col) => {
                    const obj = rstore.objectChooserStore.getProjectObject(rowid);
                    if (obj != undefined && id === rowid + "_name") {
                        if (obj.type === ProjectObjectType.Bookmark) {
                            return React.createElement(BookmarkUI, { bookmark: obj });
                        }
                    }
                    if (obj != undefined && id === rowid + "_type") {
                        const dtype = obj.type === ProjectObjectType.Draft ? obj.drafttype : undefined;
                        return React.createElement(Flex, { flexWrap: 'wrap', title: col.data.toString(), justifyContent: 'center', padding: '8px' }, this.getIcon(obj.type, dtype));
                    }
                    return undefined;
                }, folderid: rstore.objectChooserStore.activefolderid, totalcount: rstore.objectChooserStore.getObjects().filter((obj) => obj.type !== ProjectObjectType.Folder && obj.parentid === rstore.objectChooserStore.activefolderid).length }));
    }
};
DocumentTable.contextType = StoreContext;
DocumentTable = __decorate([
    observer
], DocumentTable);
let NewObjectRow = class NewObjectRow extends React.Component {
    constructor(prop) {
        super(prop);
    }
    getIcon(type, drafttype) {
        if (type === ProjectObjectType.Document) {
            return React.createElement(Icon, { ml: '5px', color: AppColor.FileIconColor, h: '20px', w: '20px', as: FaRegFilePdf, alignSelf: 'center' });
        }
        else if (type === ProjectObjectType.Draft) {
            if (drafttype !== undefined && drafttype === DraftType.DOCX) {
                return React.createElement(Icon, { ml: '5px', color: AppColor.FileIconColor, h: '20px', w: '20px', as: FaFileWord, alignSelf: 'center' });
            }
            else if (drafttype !== undefined && drafttype === DraftType.XLSX) {
                return React.createElement(Icon, { ml: '5px', color: AppColor.FileIconColor, h: '20px', w: '20px', as: FaFileExcel, alignSelf: 'center' });
            }
            else if (drafttype !== undefined && drafttype === DraftType.Diagram) {
                return React.createElement(Icon, { ml: '5px', color: AppColor.FileIconColor, h: '20px', w: '20px', as: FaProjectDiagram, alignSelf: 'center' });
            }
            else if (drafttype !== undefined && drafttype === DraftType.PPTX) {
                return React.createElement(Icon, { ml: '5px', color: AppColor.FileIconColor, h: '20px', w: '20px', as: FaFile, alignSelf: 'center' });
            }
        }
        else if (type === ProjectObjectType.Bookmark) {
            return React.createElement(Icon, { ml: '5px', color: AppColor.FileIconColor, h: '20px', w: '20px', as: MdBookmarkBorder, alignSelf: 'center' });
        }
        else {
            return React.createElement(Icon, { ml: '5px', color: AppColor.FileIconColor, h: '20px', w: '20px', as: FaFile, alignSelf: 'center' });
        }
    }
    copyLinkPassword(password, label) {
        const rstore = this.context;
        Clipboard(password);
        rstore.aletrDialogStore.setMessage("Copied " + label + " to clipboard");
        rstore.aletrDialogStore.setOpen(true);
    }
    selectOrUnselectRow() {
    }
    render() {
        var _a;
        const rstore = this.context;
        const obj = rstore.objectChooserStore.getProjectObject(this.props.objectrow.id);
        const rowid = this.props.objectrow.id;
        if (obj === undefined) {
            return React.createElement(React.Fragment, null);
        }
        const emap = new Map();
        for (const en of (_a = obj.metadata) !== null && _a !== void 0 ? _a : []) {
            emap.set(en.fieldid, en);
        }
        return React.createElement(React.Fragment, null,
            React.createElement("td", { style: {
                    'backgroundColor': rstore.objectChooserStore.activeitemid === this.props.objectrow.id ? '#829eb975' : undefined
                }, onClick: () => this.props.onSelect(obj, !(rstore.objectChooserStore.activeitemid === obj.id)) }),
            this.props.objectrow.row.map((item, index) => {
                var _a, _b, _c;
                if (item.id === rowid + "_name") {
                    if (item.type === ProjectObjectType.Bookmark) {
                        return React.createElement("td", { onClick: () => this.props.onSelect(obj, !(rstore.objectChooserStore.activeitemid === obj.id)), key: obj.id + "_" + index, style: {
                                'backgroundColor': rstore.objectChooserStore.activeitemid === this.props.objectrow.id ? '#829eb975' : undefined
                            } },
                            React.createElement(BookmarkUI, { bookmark: obj }));
                    }
                }
                if (item.id === rowid + "_type") {
                    const dtype = item.type === ProjectObjectType.Draft ? obj.drafttype : undefined;
                    return React.createElement("td", { style: {
                            'backgroundColor': rstore.objectChooserStore.activeitemid === this.props.objectrow.id ? '#829eb975' : undefined
                        }, onClick: () => this.props.onSelect(obj, !(rstore.objectChooserStore.activeitemid === obj.id)), key: obj.id + "_" + index },
                        React.createElement(Flex, { flexWrap: 'wrap', title: item.data.toString(), align: 'center', padding: '8px' }, this.getIcon(obj.type, dtype)));
                }
                if (item.id.startsWith("custom_")) {
                    const fid = item.id.substring("custom_".length);
                    const aen = emap.get(fid);
                    const en = (_a = aen === null || aen === void 0 ? void 0 : aen.datastr) !== null && _a !== void 0 ? _a : '';
                    const entry = rstore.objectChooserStore.metaitems.get(fid);
                    if (entry) {
                        if (!en) {
                            return React.createElement("td", { onClick: () => this.props.onSelect(obj, !(rstore.objectChooserStore.activeitemid === obj.id)), style: { 'backgroundColor': rstore.objectChooserStore.activeitemid === this.props.objectrow.id ? '#829eb975' : undefined }, key: entry.id }, entry.type === SchemaItemType.Boolean &&
                                React.createElement(Checkbox, { checked: false }));
                        }
                        let choices = [];
                        let udata = undefined;
                        if (aen && entry.type === SchemaItemType.Choice) {
                            const ebots = en.split(",");
                            if (ebots.length > 0) {
                                if (!entry.multiselect) {
                                    const cval = ebots[0];
                                    for (const val of entry.items) {
                                        if (cval === (val.id)) {
                                            choices.push(val);
                                            break;
                                        }
                                    }
                                }
                                else {
                                    for (const val of entry.items) {
                                        if (ebots.indexOf(val.id) !== -1) {
                                            choices.push(val);
                                        }
                                    }
                                }
                            }
                        }
                        else if (entry.type === SchemaItemType.UserChoice) {
                            const ebots = en.split(",");
                            if (ebots.length > 0) {
                                const users = [...rstore.letrAndTagStore.actveltermembers.map((mem) => ({ id: mem.id, name: mem.name + " (" + mem.orgname + ")", type: ChoiceType.Text })),
                                    ...Array.from(rstore.letrDetailStore.letrlinks.values()).map((link) => ({ id: "freesoul-" + link.id, name: link.name + " (External Link)", type: ChoiceType.Text }))];
                                if (!entry.multiselect) {
                                    const cval = ebots[0];
                                    for (const val of users) {
                                        if (cval === (val.id)) {
                                            choices.push(val);
                                            break;
                                        }
                                    }
                                }
                                else {
                                    for (const val of users) {
                                        if (ebots.indexOf(val.id) !== -1) {
                                            choices.push(val);
                                        }
                                    }
                                }
                            }
                        }
                        if (en && entry.type === SchemaItemType.URL) {
                            try {
                                udata = JSON.parse(en);
                            }
                            catch (ex) { }
                        }
                        return React.createElement("td", { onClick: () => this.props.onSelect(obj, !(rstore.objectChooserStore.activeitemid === obj.id)), style: { 'backgroundColor': rstore.objectChooserStore.activeitemid === this.props.objectrow.id ? '#829eb975' : undefined }, key: (_b = aen === null || aen === void 0 ? void 0 : aen.id) !== null && _b !== void 0 ? _b : Math.random() + "" },
                            entry.type === SchemaItemType.Text && React.createElement(Box, { dangerouslySetInnerHTML: { __html: en } }),
                            entry.type === SchemaItemType.Date && React.createElement(Flex, { w: '100%', justify: 'center' },
                                React.createElement(Text, null, DateLib.displayDateWIthFormat(en, entry.inlcudetime, (_c = entry.excludedate) !== null && _c !== void 0 ? _c : false))),
                            entry.type === SchemaItemType.Choice && choices.length > 0 && !entry.multiselect && React.createElement(Flex, { w: '100%', justify: 'center' },
                                React.createElement(Text, null, choices != undefined && choices.length > 0 ? choices[0].name : '')),
                            entry.type === SchemaItemType.Choice && choices.length > 0 && entry.multiselect && React.createElement(Flex, { flexWrap: 'wrap', w: '100%', justify: 'center' }, choices.map((ch) => React.createElement(Tag, { key: ch.id, m: '3px' }, ch.name))),
                            entry.type === SchemaItemType.Color && React.createElement(Box, { w: '20px', h: '20px', borderRadius: '10px', bg: en }),
                            entry.type === SchemaItemType.Boolean && React.createElement(Checkbox, { checked: en === 'true' ? true : false }),
                            entry.type === SchemaItemType.Number && React.createElement(Flex, { w: '100%', paddingRight: '5px' }, en),
                            entry.type === SchemaItemType.FormInput && React.createElement(Flex, { align: 'center' },
                                React.createElement(Text, null, entry.enablesecret ? '****' : en),
                                entry.enablesecret && React.createElement(Icon, { onClick: (e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.copyLinkPassword(en, entry.name);
                                    }, as: FaClipboard, ml: '5px' })),
                            entry.type === SchemaItemType.URL && udata !== undefined && React.createElement(Link, { href: (entry.scheme + "" + udata.url), isExternal: true },
                                udata.name !== '' ? udata.name :
                                    (entry.scheme + "" + udata.url),
                                React.createElement(Icon, { as: FiExternalLink, mx: '2px' })),
                            entry.type === SchemaItemType.UserChoice && !entry.multiselect && React.createElement(Flex, { w: '100%', justify: 'center' },
                                React.createElement(Text, null, choices != undefined && choices.length > 0 ? choices[0].name : '')),
                            entry.type === SchemaItemType.UserChoice && entry.multiselect && React.createElement(Flex, { flexWrap: 'wrap', w: '100%', justify: 'center' }, choices.map((ch) => React.createElement(Tag, { key: ch.id, m: '3px' }, ch.name))));
                    }
                }
                return React.createElement("td", { onClick: () => this.props.onSelect(obj, !(rstore.objectChooserStore.activeitemid === obj.id)), key: obj.id + "_" + index, style: {
                        'backgroundColor': rstore.objectChooserStore.activeitemid === this.props.objectrow.id ? '#829eb975' : undefined
                    } },
                    React.createElement(Flex, { align: 'center' },
                        React.createElement(Text, { padding: '8px' }, item.data)));
            }));
    }
};
NewObjectRow.contextType = StoreContext;
NewObjectRow = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], NewObjectRow);
export { NewObjectRow };
let BookmarkUI = class BookmarkUI extends React.Component {
    constructor(prop) {
        super(prop);
        this.state = {
            showdetail: false
        };
    }
    render() {
        const islink = (this.props.bookmark.url.startsWith("http://") || this.props.bookmark.url.startsWith("https://")
            || this.props.bookmark.url.startsWith("www."));
        return React.createElement(Box, null,
            React.createElement(Accordion, { allowToggle: true },
                React.createElement(AccordionItem, { className: 'accordion-item' },
                    React.createElement(AccordionButton, { className: 'accordion-button', onClick: (e) => {
                            this.setState({ showdetail: !this.state.showdetail });
                        } },
                        React.createElement(Flex, { position: 'relative', _hover: { cursor: 'pointer', textDecoration: 'underline' } },
                            this.props.bookmark.accessids !== undefined && this.props.bookmark.accessids.indexOf("everyone") === -1 &&
                                this.props.bookmark.accessids.length > 0 && React.createElement(Icon, { as: FiLock, color: 'red', position: 'absolute', top: '-11px', left: '11px' }),
                            React.createElement(Text, { paddingLeft: '8px' }, this.props.bookmark.name))),
                    React.createElement(AccordionPanel, { pb: 4 }, this.state.showdetail && React.createElement(Box, { mt: '10px' },
                        islink && React.createElement(Link, { textDecoration: 'underline', color: 'blue', href: this.props.bookmark.url, isExternal: true }, this.props.bookmark.url),
                        !islink && React.createElement(Text, { color: 'black' }, this.props.bookmark.url))))));
    }
};
BookmarkUI.contextType = StoreContext;
BookmarkUI = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], BookmarkUI);
